import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApPaginatorComponent } from '@ap/paginator';

import {
    ApCellDefDirective,
    ApCellDirective,
    ApColumnDefDirective,
    ApFooterCellDefDirective,
    ApFooterCellDirective,
    ApHiddenCellDirective,
    ApHeaderCellDefDirective,
    ApHeaderCellDirective
} from './cell/cell.directive';
import { ApFooterRowComponent, ApHeaderRowComponent, ApRowComponent, ApSubTableRowComponent } from './row/row.component';
import { ApFooterRowDefDirective, ApHeaderRowDefDirective, ApRowDefDirective } from './row/row.directive';
import { ApTableComponent } from './table.component';

const EXPORTED_DECLARATIONS = [
    // Table
    ApTableComponent,

    // Template defs
    ApCellDefDirective,
    ApHeaderCellDefDirective,
    ApColumnDefDirective,

    // Cell directives
    ApHeaderCellDirective,
    ApFooterCellDirective,
    ApFooterCellDefDirective,
    ApCellDirective,
    ApHiddenCellDirective,

    // Row directions
    ApHeaderRowComponent,
    ApFooterRowComponent,
    ApRowComponent,
    ApSubTableRowComponent
];

/**
 * @ngdoc module
 * @name ApTableModule
 */
@NgModule({
    imports: [
        CdkTableModule,
        CommonModule,
        ApPaginatorComponent,
        ApHeaderRowDefDirective,
        ApRowDefDirective,
        ApFooterRowDefDirective,
        ...EXPORTED_DECLARATIONS
    ],
    exports: [...EXPORTED_DECLARATIONS, ApHeaderRowDefDirective, ApRowDefDirective, ApFooterRowDefDirective]
})
export class ApTableModule {}
